import { render } from "./xtx-message.vue?vue&type=template&id=7d835598&scoped=true"
import script from "./xtx-message.vue?vue&type=script&lang=js"
export * from "./xtx-message.vue?vue&type=script&lang=js"

import "./xtx-message.vue?vue&type=style&index=0&id=7d835598&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d835598"]])

export default __exports__